import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  UntypedFormControl
} from '@angular/forms';
import { Subject } from 'rxjs';

@Component({
  selector: 'textarea-input',
  templateUrl: './textarea-input.component.html',
  styleUrls: ['./textarea-input.component.scss']
})
export class TextareaInputComponent implements OnInit, OnChanges {
  formGroup: UntypedFormGroup;
  @Input()
  public title: string;
  @Input()
  public subtitle: string;
  @Input()
  public initContent: string;
  @Input()
  public showOnly = false;
  @Input()
  public placeholder = 'Geef hier een gepersonaliseerde tekst';
  @Input()
  public answerChange: Subject<string>;
  @Input()
  minHeight = 0;
  @Input()
  public disabled = false;
  @Input()
  public client = false;
  @Input()
  public sensitive = false;
  @Input()
  public focusAndSelect = false;

  @Output()
  public answer = new EventEmitter();

  constructor(private formBuilder: UntypedFormBuilder) {}

  ngOnInit() {
    this.formGroup = this.initTextareaForm();
    if (this.disabled) {
      this.formGroup.get('answer').disable();
    }
    if (this.answerChange != null) {
      this.answerChange.subscribe(a => {
        this.formGroup.get('answer').setValue(a);
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.formGroup == null) {
      return;
    }
    if (changes.disabled) {
      if (changes.disabled.currentValue === true) {
        this.formGroup.get('answer').disable();
      } else if (changes.disabled.currentValue === false) {
        this.formGroup.get('answer').enable();
      }
    }
    if ((changes.initContent && this.showOnly) || this.sensitive) {
      this.formGroup.get('answer').setValue(changes.initContent.currentValue);
    }
  }

  initTextareaForm() {
    return this.formBuilder.group({
      answer: new UntypedFormControl(
        this.initContent != null ? this.initContent : ''
      )
    });
  }

  answered(value) {
    this.answer.emit(this.formGroup.get('answer').value);
  }

  getMinHeigt() {
    let styles = { 'min-height': this.minHeight };
    return styles;
  }
}
